module.exports = __webpack_public_path__ + "img/Password.82f5cb36.svg";